var Vendd = (function (Vendd) {
    'use strict';

    Vendd.InvoiceAccess = (function (InvoiceAccess) {

        InvoiceAccess.Messages = (function (Messages) {

            Messages.Submit = function (orderCode, orderPhone, reCaptchaCode) {
                var data = {
                    orderCode: orderCode,
                    orderPhone: orderPhone,
                    reCaptchaCode: reCaptchaCode
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.InvoiceAccess.Messages.Submit', data);
            };
            Messages.Submit.className = 'Vendd.InvoiceAccess.Messages.Submit';

            Messages.SubmitSuccess = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.InvoiceAccess.Messages.SubmitSuccess', response);
            };
            Messages.SubmitSuccess.className = 'Vendd.InvoiceAccess.Messages.SubmitSuccess';

            Messages.SubmitFailure = function (response) {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.InvoiceAccess.Messages.SubmitFailure', response);
            };
            Messages.SubmitFailure.className = 'Vendd.InvoiceAccess.Messages.SubmitFailure';

            return Messages;

        })(InvoiceAccess.Messages || {});

        return InvoiceAccess;

    })(Vendd.InvoiceAccess || {});

    return Vendd;

})(Vendd || {});